/**
 * desc: 获取直播列表
 * method: get
 */
import axios from '../../axios'
import UserStore from '@stores/UserStore'
import { addZhiniaoPrefix } from '@utils/SSOHelper'

export default {
  queryLiveList: (sid: string, pageNumber: number, tabType: string) => {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/live/privation/queryLiveRoomsByStatus.do'), {
      params: {
        curPage: pageNumber,
        numPerPage: 30,
        /** 是否支持互动直播版本 0 不支持 1 支持 */
        supportInteractive: 1,
        /** tabType 直播间列表类型,1 未开始和正在直播,2 直播回放 */
        tabType,
        /** 1 普通包含学堂直播 */
        includeSchoolLive: '1',
        /** 不包含我是主播的直播间 0 不包含 1包含 */
        includeAnchorLive: '1', // 220422版本开发web开播功能，需要展示主播的直播间
        /** 是否压缩 */
      },
    })
  },
  checkViewerReachEnterpriseLimit: (roomId: string, enterpriseId: string) => {
    return axios.get(
      addZhiniaoPrefix('/learn/app/clientapi/live/checkViewerReachEnterpriseLimit.do'),
      {
        params: {
          roomId,
          enterpriseId,
        },
      }
    )
  },

  // 获取用户信息列表
  getSignInList: (roomId: string, signOutFlag: number, sessionId: string) => {
    return axios.post(
      addZhiniaoPrefix('/learn/app/clientapi/live/signin/zmh/getSignInList.do'),
      {
        roomId,
        signOutFlag,
        sessionId,
      },
      {
        params: { noInterceptorCancel: true },
      }
    )
  },

  // 查询签到列表是否有更新
  isLoadSignList: (roomId: string, signOutFlag: number, sessionId: string) => {
    return axios.post(
      addZhiniaoPrefix('/learn/app/clientapi/live/signin/zmh/isLoadSignList.do'),
      {
        roomId,
        signOutFlag,
        sessionId,
      },
      {
        params: { noInterceptorCancel: true },
      }
    )
  },

  // 获取512px二维码
  getQrCode: (qrCodeText: string) => {
    return axios.post(
      addZhiniaoPrefix('/learn/app/clientapi/live/qrcode/create.do'),
      {
        qrType: 'DEFAULT',
        mode: 1,
        qrCodeText,
        // isRedirect: 0,
        w: 512,
        h: 512,
      },
      {
        headers: {
          sid: UserStore.getSid(),
          'Content-Type': 'application/json;charset=UTF-8',
        },
        params: { noInterceptorCancel: true },
      }
    )
  },

  // 获取正常尺寸二维码
  getNorMalQrCode: (qrCodeText: string) => {
    return axios.post(
      addZhiniaoPrefix('/learn/app/clientapi/live/qrcode/create.do'),
      {
        qrType: 'DEFAULT',
        qrCodeText,
        mode: 1,
      },
      {
        headers: {
          sid: UserStore.getSid(),
          'Content-Type': 'application/json;charset=UTF-8',
        },
        params: { noInterceptorCancel: true },
      }
    )
  },

  // 保存位置信息
  saveLocation: (params: any) => {
    return axios.post(addZhiniaoPrefix('/learn/app/clientapi/live/signin/zmh/location.do'), {
      ...params,
    })
  },

  // 会议中间页二维码--不需要登录
  getMeetingCode: (qrCodeText: string) => {
    return axios.post(
      addZhiniaoPrefix('/learn/app/clientapi/live/qrcode/createWithoutLogin.do'),
      {
        qrType: 'DEFAULT',
        qrCodeText,
      },
      {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }
    )
  },

  // 会议中间页
  getMeetingDetail: (meetingId: string) => {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/meeting/shareDetail.do'), {
      params: {
        meetingId,
      },
    })
  },

  // 是否开启地图
  getOpenMapFlag: () => {
    return axios.post(
      addZhiniaoPrefix('/learn/app/clientapi/live/signin/zmh/isDistanceCheck.do'),
      {},
      {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }
    )
  },

  /** 增值服务 */
  queryVasOperation2NativeList: () => {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/misc/queryVasOperation2NativeList.do'))
  },

  // 获取自然人直播列表
  getNaturalLiveList: (data) => {
    const { sid, pageNo, status } = data
    return axios.get(
      addZhiniaoPrefix('/learn/app/clientapi/live/learn/consumer/list.do'),
      {
        params: {
          sid,
          pageNo,
          pageSize: 12,
          status
        },

      }
    )
  },
  // 自然人、学习卡查询直播详细信息
  getLiveInfo: (data) => {
    const {roomId, fromType,sid} = data
    return axios.get(
      addZhiniaoPrefix('/learn/app/clientapi/live/detailInfo.do'),
      {
        params: {
          sid,
          roomId,
          fromType,
        },
      }
    )
  }
}
